<ng-container *ngIf="user$ | async as user; else login">
  <ng-container *ngIf="greeting$ | async as greeting">
    <div class="cx-login-greet">
      {{ greeting$ | async }}
    </div>
    <cx-page-slot
      (cxDomChange)="onRootNavBtnAdded($event, greeting)"
      cxDomChangeTargetSelector="nav ul li:first-child button"
      id="account-nav"
      position="HeaderLinks"
    ></cx-page-slot>
  </ng-container>
</ng-container>

<ng-template #login>
  <a role="link" [routerLink]="{ cxRoute: 'login' } | cxUrl">{{
    'miniLogin.signInRegister' | cxTranslate
  }}</a>
</ng-template>
